import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'catalog-agent',
});

/** One release's history, readable after its entity is gone. */
export const releaseHistoryRouteRef = createSubRouteRef({
  id: 'catalog-agent/release-history',
  parent: rootRouteRef,
  path: '/history/:cluster/:namespace/:release',
});
